import { render, staticRenderFns } from "./addressInfo.vue?vue&type=template&id=6bd15ec8&scoped=true"
import script from "./addressInfo.vue?vue&type=script&lang=js"
export * from "./addressInfo.vue?vue&type=script&lang=js"
import style0 from "./addressInfo.vue?vue&type=style&index=0&id=6bd15ec8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd15ec8",
  null
  
)

export default component.exports